module.exports = __webpack_public_path__ + "assets/img/bg_title.6aec844b.png";